<script lang="ts" setup>
import { UButton } from "#components";
import { TELESTRATION_TOOLTIP_CONTAINER } from "~/telestrations/constants/tooltip";

type UButtonProps = InstanceType<typeof UButton>["$props"];

const props = defineProps<
  {
    disabled?: boolean;
    tooltip?: string;
  } & /* @vue-ignore */ UButtonProps
>();
</script>

<template>
  <UButton
    v-tooltip="{
      content: props.tooltip,
      container: TELESTRATION_TOOLTIP_CONTAINER,
    }"
    v-bind="props"
    :class="props.disabled ? 'text-neutral-light-800' : ''"
    :size="props.size || 'sm'"
    :variant="props.variant || 'clean'"
  />
</template>
